(() => {
  const visibleForms = new Set();
  const observedForms = new Set();
  const updateLauncher = () => document.body.classList.toggle('pavels-club-form-in-view', visibleForms.size > 0);
  const visibility = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) visibleForms.add(entry.target);
      else visibleForms.delete(entry.target);
    });
    updateLauncher();
  });
  const update = () => {
    observedForms.forEach(form => {
      if (!form.isConnected) {
        visibility.unobserve(form);
        observedForms.delete(form);
        visibleForms.delete(form);
      }
    });
    document.querySelectorAll('.pavels-newsletter-restored .klaviyo-form-T2HQ3c form').forEach(form => {
      if (!observedForms.has(form)) {
        observedForms.add(form);
        visibility.observe(form);
      }
      form.querySelectorAll('input[type="tel"]').forEach(input => {
        if (input.placeholder === 'Deine Handynummer (optional)') input.placeholder = 'Handynummer';
      });
    });
    updateLauncher();
  };
  const init = () => {
    document.querySelectorAll('.pavels-newsletter-restored').forEach(root => {
      if (root.dataset.pavelsMobileReady) return;
      root.dataset.pavelsMobileReady = 'true';
      new MutationObserver(update).observe(root, {childList: true, subtree: true});
    });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
